import { Modal, Paper, Typography, TextField, InputAdornment, Button, CircularProgress } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { updatePostback, listPostback } from 'store/Orbita/Product/actions';

import type { DispatchProp } from 'react-redux';

const decorate = withStyles((theme) => ({
  modalPostback: {
    padding: '1.5rem',
    width: '95vw',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.up('md')]: {
      width: 640,
    },
  },
}));

interface IProps extends DispatchProp<{}>, StyledComponentProps {
  open: boolean;
  productId?: number;
  product: any;
  url: any;
  newUrl: any;
  onClose: any;
}

class PostbackModal extends Component<IProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      url: '',
    };
  }

  handleSubmit = () => {
    (async () => {
      try {
        await this.props.dispatch(updatePostback(this.props.product.id, this.state.url, 'POSTBACK', 'URL'));
        toast.success('Url de postback atualizada!');
        if (this.props.onClose) {
          this.props.onClose();
        }
      } catch (error) {
        toast.error('Ops, erro ao atualizar a url de postback!');
      }
    })();
  };

  componentDidMount() {
    (async () => {
      try {
        await this.props.dispatch(listPostback(this.props.product.id, 'POSTBACK', 'URL'));
        if (this.props.url.data.length > 0) {
          this.setState({ url: this.props.url.data[0].script });
        }
      } catch (error) {}
    })();
  }

  render() {
    const { classes } = this.props;
    return (
      <Modal open={this.props.open} onClose={this.props.onClose}>
        <Paper className={classes.modalPostback}>
          <Typography variant='h6' style={{ color: '#192542' }}>
            URL de Postback
          </Typography>
          <div className='m16' />O recurso de postback permite que você receba notificações de alguns eventos que ocorrem dentro do sistema,
          possibilitando que além do produtor, o afiliado também tenha um melhor controle sobre seu negócio.{' '}
          <a target='_blank' rel='noopener noreferrer' href='https://github.com/deveduzz/postback-eduzz'>
            <strong>Saiba mais</strong>
          </a>
          <Typography variant='subtitle1' style={{ color: '#818B9D' }}></Typography>
          <div className='m24' />
          <TextField
            fullWidth
            helperText='Ex: http://www.meusite.com/postback'
            value={this.state.url}
            onChange={(e: any) => this.setState({ url: e.target.value })}
            InputProps={{
              disableUnderline: true,
              startAdornment: <InputAdornment position='start'>URL</InputAdornment>,
              endAdornment:
                this.props.url.isFetching || this.props.newUrl.isFetching ? (
                  <CircularProgress size={14} style={{ marginRight: '0.5rem' }} />
                ) : (
                  <IconButton aria-label='clear postback url' onClick={() => this.setState({ url: '' })} edge='end'>
                    <ClearIcon />
                  </IconButton>
                ),
            }}
          ></TextField>
          <div className='m16' />
          <div style={{ textAlign: 'right' }}>
            <Button color='default' disabled={this.props.url.isFetching || this.props.newUrl.isFetching} onClick={this.props.onClose}>
              Fechar
            </Button>
            <Button
              color='secondary'
              variant='contained'
              disabled={(this.props.url && this.props.url.isFetching) || (this.props.newUrl && this.props.newUrl.isFetching)}
              onClick={this.handleSubmit}
            >
              Salvar
            </Button>
          </div>
        </Paper>
      </Modal>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    newUrl: state.orbita.Product.updatePostback,
    url: state.orbita.Product.listPostback,
  };
}

export default decorate(connect(mapStateToProps)(PostbackModal)) as any;
